"use client";

import { ConsentManagerDialog as C15tConsentManagerDialog } from "@c15t/nextjs";
import type { ComponentProps } from "react";

type ConsentDialogProps = ComponentProps<typeof C15tConsentManagerDialog>;

export function ConsentDialog(props: ConsentDialogProps) {
  return (
    <C15tConsentManagerDialog
      {...props}
      theme={{
        "widget.accordion": "space-y-2",
        "widget.accordion.arrow.close": "transform",
        "widget.accordion.arrow.open": "rotate-180 transform",
        "widget.accordion.content": "overflow-hidden",
        "widget.accordion.content-inner":
          "p-4 pt-0 text-sm text-muted-foreground",
        "widget.accordion.icon": "h-4 w-4",
        "widget.accordion.item":
          "border border-border rounded-md overflow-hidden",
        "widget.accordion.trigger":
          "flex w-full items-center justify-between p-4 text-left font-medium hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground focus:outline-none",
        "widget.accordion.trigger-inner": "flex items-center gap-2",
        "widget.footer": "border-t border-border flex gap-3",
        "widget.footer.accept-button":
          "inline-flex w-full sm:w-auto shrink-0 items-center justify-center rounded-md font-medium text-sm ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 h-10 px-4 py-2 bg-primary text-primary-foreground hover:bg-primary/90",
        "widget.footer.customize-button":
          "inline-flex shrink-0 items-center justify-center rounded-md font-medium text-sm ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 h-10 px-4 py-2 border border-input bg-background hover:bg-accent hover:text-accent-foreground",
        "widget.footer.reject-button":
          "inline-flex w-full sm:w-auto shrink-0 items-center justify-center rounded-md font-medium text-sm ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 h-10 px-4 py-2 border border-input bg-background hover:bg-accent hover:text-accent-foreground",
        "widget.footer.save-button":
          "inline-flex shrink-0 items-center justify-center rounded-md font-medium text-sm ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 h-10 px-4 py-2 bg-primary text-primary-foreground hover:bg-primary/90",
        "widget.footer.sub-group": "flex flex-col sm:flex-row gap-2",
        "widget.root": "bg-background text-foreground",
        "widget.switch":
          "relative inline-flex h-6 w-[44px] items-center rounded-full border-2 border-transparent transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50",
        "widget.switch.thumb": {
          className:
            "pointer-events-none block h-5 w-5 rounded-full bg-background shadow-lg ring-0",
          style: {
            "--switch-thumb-translate": "1rem"
          }
        },
        "widget.switch.track": {
          className:
            "h-6 w-[44px] rounded-full bg-primary transition-colors data-[state=checked]:bg-primary",
          style: {
            "--switch-background-color-checked": "var(--primary)"
          }
        },
        ...props.theme
      }}
    />
  );
}
